/* eslint-disable react/no-unknown-property */
import { ColorPalettes } from '../Landing/LandingBlock/LandingBlock';
import { SocialButton } from '../SocialButton/SocialButton';
import { SocialMedias } from '../NavBar/NavBar';
import styles from './Footer.module.scss';

interface FooterProps {
  colorPalette: ColorPalettes;
  social?: SocialMedias;
}

export const Footer = ({ colorPalette, social = null }: FooterProps) => {
  const hasSocial = Boolean(social?.whatsapp || social?.facebook);

  return (
    <footer color-palette={colorPalette} className={styles.root}>
      <div className={styles.content}>
        <div className={styles.info}>
          Jessica P. Quintanilla Flores - Quick call: 3310504287 | Developed by
          QUIROBA Soft
        </div>
        {hasSocial && (
          <div className={styles.social} aria-label="Social media">
            {social.whatsapp && (
              <SocialButton
                className={styles['social-button']}
                socialType="whatsapp"
                link={social.whatsapp.link}
              />
            )}
            {social.facebook && (
              <SocialButton
                className={styles['social-button']}
                socialType="facebook"
                link={social.facebook.link}
              />
            )}
          </div>
        )}
      </div>
    </footer>
  );
};
